export enum ActivityLocationTypes {
    //В папках (на исполнении на контроле)
    PerformerFolder = 0,
    //В карточке документа
    DocumentView = 1,
    // В заголовке карточки документа
    DocumentTitleBar = 2,
}
